import { twMerge } from "tailwind-merge";
import { Button } from "@/atoms-react/button/Button.react";
import { Themes } from "@/types/theme";
import { AttributesHtmlElement, buttonAction } from "@/features/partner/types";
import { Base, Title } from "@/atoms-react/text/Text.react";
import { UserType } from "@/features/user/types";
import { getWebBankingUrl } from "@/features/utils/web-banking-url";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { useKYCContext } from "@/features/auth/hooks/use-kyc-context";

type dashCardPropsType = {
  openAction?: (action: string) => void;
  bgUrl?: string;
  btnText?: string;
  action?: string;
  allowedToKypay?: boolean;
  allowedToPaticipate?: boolean;
  button_text_attribute?: string;
  user?: UserType;
  position?: string;
};
export const DashboardCard = ({
  openAction,
  bgUrl,
  btnText,
  action,
  allowedToKypay,
  allowedToPaticipate,
  button_text_attribute,
  user,
  position
}: dashCardPropsType) => {
  const olkyCardsClassName = "w-full h-full p-2 xl:p-4  flex ";
  const baseTextClassName = "text-white font-semibold mt-0 mb-2 z-10";
  const partner = sessionStorage.getItem("origin");
  const { getLanguage } = usei18n();
  const redirectToBankAccount = () => {
    let email = user?.naturalPerson.AliasEmail.find((email) => email.Actif === true)?.Mail;
    if (!email && (user?.naturalPerson?.AliasEmail?.length as number) > 0) {
      email = user?.naturalPerson.AliasEmail[0].Mail;
    }
    const url = getWebBankingUrl(email);
    const success = window.open(url, "_blank");
    if (!success) document.location = url;
  };
  const { t } = useTranslation(["pass"]);
  const { auditPending } = useKYCContext();
  return (
    <>
      <div
        className={twMerge(
          "h-[188px] w-full overflow-hidden rounded-sm opacity-1 lg:h-[188px] xl:h-[223px] 2xl:h-[223px]"
        )}
      >
        <div
          style={{ "--image-url": `url(${bgUrl})` } as React.CSSProperties}
          className={twMerge(
            `${olkyCardsClassName} relative bg-[image:var(--image-url)] bg-center bg-cover`,
            action === buttonAction.READMORE &&
              (!btnText || btnText?.trim().length === 0) &&
              "cursor-pointer"
          )}
          onClick={
            action === buttonAction.READMORE && (!btnText || btnText?.trim().length === 0)
              ? () => {
                  openAction?.(action as string);
                }
              : undefined
          }
        >
          <div
            className={twMerge(
              `mx-2 mt-auto mb-2 flex flex-1 justify-center ${
                position === "center"
                  ? "justify-center"
                  : position === "left"
                    ? "justify-start"
                    : position === "right"
                      ? "justify-end"
                      : ""
              } `,
              action === buttonAction.READMORE && "justify-start"
            )}
          >
            {action === buttonAction.READMORE ? (
              <Base
                onClick={() => {
                  openAction?.(action as string);
                }}
                className={twMerge(
                  "cursor-pointer text-white",
                  button_text_attribute === AttributesHtmlElement.black && "text-black"
                )}
              >
                {" "}
                {btnText}
              </Base>
            ) : action === buttonAction.CREATE_ACCOUNT ? (
              user && user?.naturalPerson?.codeShop !== null ? (
                <div className="absolute top-0 flex h-full w-full flex-col p-4 md:p-6">
                  <Base className={twMerge(baseTextClassName, "mb-0")}>
                    {" "}
                    {t("olkypass.general.olky_account_conso")}
                  </Base>
                  <Title className="z-0 mb-0 w-max rounded-xl text-white backdrop-blur">
                    {new Intl.NumberFormat(getLanguage() === "fr" ? "fr-FR" : "en-US", {
                      style: "currency",
                      currency: "EUR",
                      currencyDisplay: "narrowSymbol"
                    }).format(parseFloat(user.naturalPerson.olkyAccount?.balance ?? "0"))}
                  </Title>
                  <div className="mt-auto flex flex-1 items-end">
                    <Button
                      onClick={redirectToBankAccount}
                      size="md"
                      theme={Themes.white}
                      className="mt-4 h-8 w-auto border-none text-start text-black text-primary text-xs hover:bg-slate-50 sm:h-10 sm:text-base md:w-96 lg:h-8 lg:w-auto lg:text-sm xl:h-10 xl:text-base xl:text-lg dark:bg-white dark:text-black dark:text-primary dark:hover:bg-slate-50"
                      icon={<ArrowTopRightOnSquareIcon />}
                    >
                      {t("olkypass.mainPage.olkypass.bloc2.btn_access_partner", {
                        partner: `${partner?.charAt(0)?.toUpperCase()}${partner?.slice(1)}`
                      })}
                    </Button>
                  </div>
                </div>
              ) : user?.naturalPerson?.olkypay_account_requested === 1 ? (
                <Base className={twMerge("item-start flex justify-start text-sm text-white")}>
                  {t("olkypass.general.olky_account_pending")}{" "}
                </Base>
              ) : (
                <Button
                  size="md"
                  disabled={
                    allowedToKypay === false ||
                    user?.naturalPerson?.olkypay_account_requested === 1 ||
                    auditPending
                  }
                  theme={Themes.white}
                  onClick={() => {
                    if (
                      allowedToKypay === false ||
                      user?.naturalPerson?.olkypay_account_requested === 1
                    )
                      return;
                    openAction?.(action as string);
                  }}
                  className={twMerge(
                    "h-8 w-auto border-none bg-white text-black text-xs sm:h-10 sm:w-auto sm:text-sm md:w-auto lg:h-8 lg:w-auto lg:text-sm xl:h-10 xl:w-auto xl:text-base xl:text-base dark:bg-white dark:text-black dark:hover:bg-slate-200",

                    (allowedToKypay === false ||
                      user?.naturalPerson?.olkypay_account_requested === 1) &&
                      "opacity-80"
                  )}
                >
                  {btnText}
                </Button>
              )
            ) : (
              <Button
                size="md"
                disabled={
                  (action === buttonAction.PARTICIPATE &&
                    (!allowedToKypay || !allowedToPaticipate)) ||
                  (action === buttonAction.REDIRECT && !allowedToKypay)
                }
                theme={Themes.white}
                onClick={() => openAction?.(action as string)}
                className={twMerge(
                  "h-8 w-auto border-none bg-white text-black text-xs sm:h-10 sm:w-auto sm:text-sm md:w-auto lg:h-8 lg:w-auto lg:text-sm xl:h-10 xl:w-auto xl:text-base xl:text-base dark:bg-white dark:text-black dark:hover:bg-slate-200",
                  ((action === buttonAction.PARTICIPATE &&
                    (!allowedToKypay || !allowedToPaticipate)) ||
                    (action === buttonAction.REDIRECT && !allowedToKypay)) &&
                    "opacity-80"
                )}
              >
                {btnText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
